import { Icon, Text } from '@betterment/samba-react';

export function TaxImpactGainLossWashSaleWarning() {
  return (
    <Text as="span" color="text.warning" variant="text50" css={{ display: 'flex', gap: 'space.25' }}>
      <Icon name="WarningFilled" size="xsmall" color="icon.warning" />
      Includes washed losses.
    </Text>
  );
}
